<template>
  <div
    ref="chartRef"
    style="width: 100%; height: 600px;"
  />
</template>

<script setup>
import * as echarts from 'echarts'
import { nextTick, onMounted, ref, watch } from 'vue'

const props = defineProps({
  xAxisData: {
    type: Array,
    required: true,
  },
  seriesData: {
    type: Array,
    required: true,
  },
  legendNames: {
    type: Array,
    required: true,
  },
})

const chartRef = ref(null)
let myChart = null

function initChart() {
  if (!chartRef.value) return

  if (!myChart) {
    myChart = echarts.init(chartRef.value)
  }

  const emphasisStyle = {
    itemStyle: {
      shadowBlur: 10,
      shadowColor: 'rgba(0,0,0,0.3)',
    },
  }

  const filteredXAxisData = props.xAxisData.filter(month => month !== 'Semua Bulan')

  const option = {
    legend: {
      data: props.legendNames,
      left: '10%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    xAxis: {
      type: 'category',
      data: filteredXAxisData,
      name: '',
      axisLine: { onZero: true },
      splitLine: { show: false },
      splitArea: { show: false },
      axisLabel: {
        interval: 0, 
        rotate: 0,  
      },
    },
    yAxis: {
      name: '',
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '0%', 
      containLabel: true,
    },
    series: props.seriesData.map((seriesItem, index) => ({
      name: props.legendNames[index],
      type: 'bar',
      stack: seriesItem.stack || 'total',
      emphasis: emphasisStyle,
      data: seriesItem.data,
      itemStyle: {
        color: [
          '#2c2c2c', 
          '#2878b5', 
          '#f5a623', 
          '#3f9b58',
          '#a14da0',
          '#e45555',
        ][index],
      },
    })),
  }

  myChart.setOption(option)

  myChart.resize() 
}

onMounted(() => {
  initChart()
})

watch(() => [props.xAxisData, props.seriesData], () => {
  nextTick(() => {
    if (myChart) {
      myChart.dispose() 
      myChart = null
    }
    initChart()
  })
}, { deep: true })
</script>

<style scoped>
/* Optional, if you want to add some responsive styles later */
</style>
